import { isNil, reject } from 'ramda';
import { i18n, MetadataActions, SessionSelectors, UnsavedChangesPromptActions } from 'invision-core';
import LocaleKeys from '../../../locales/keys';
import { chargePaymentInstrument, clearSelectedPaymentMethod, editPaymentInstrument, retrieveAvailablePaymentInstrumentTypes, selectPaymentMethod, setPaymentInstrumentDefault, updatePaymentAccountsOnSelectedPaymentMethod, retrieveWallet } from '../../../reducers/actions/customer.ewallet.actions';
import { DefaultPaymentMethodAutoPaySelector, EwalletErrorSelector, PaymentInstrumentSummariesSelector, PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesAutoPayViewModelSelector, PaymentIsCreatingOrEditingDataSelector, PaymentIsUpdatingAutoPaySelector, IsRetrievingEwalletDataSelector, SelectedPaymentMethodConvergentBillerPaymentInstrumentAccountsSelector, SelectedPaymentMethodSelector } from '../../../reducers/selectors/customer.ewallet.selectors';
import { DefaultBillingAddressSelector } from '../../../reducers/selectors/customer.addresses.selectors';
import { CurrentCustomerIdSelector } from '../../../reducers/selectors/customer.selectors';
import { retrieveConvergentBillerSubscriberSummary } from '../../../reducers/actions/customer.convergent.biller.actions';
import { ConvergentBillerSubscriberSummarySelector, ConvergentBillerSubscriberSummaryAccountsSelector, ConvergentBillerSubscriberSummaryPostPaidAccountSelector, ConvergentBillerSubscriberSummaryPrePaidAccountSelector, CurrentAccountSummarySelector, CurrentPostPaidAccountSummarySelector, IsFetchingSubscriberSummarySelector } from '../../../reducers/selectors/customer.convergent.biller.selectors';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { DASHBOARD_ROUTE } from '../../../reducers/constants/dashboard.constants';
import { stateGo } from 'redux-ui-router';
import { setCustomerAutoPayBannerFlag } from '../../../reducers/actions/customer.account.status.actions';
import { retrieveCustomerHouseholds } from '../../../reducers/actions/customer.household.actions';
import { CurrentHouseholdSelector, CurrentMemberHasCreatePaymentInstrumentPermissionsSelector } from '../../../reducers/selectors/customer.household.selectors';
var SUSPENSION_TYPE = {
  INDEFINITE: 'INDEFINITE',
  UNTIL: 'UNTIL'
};
function CustomerConfigureAutopayController($ngRedux, uiNotificationService, $timeout, $state) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      billingAddress: DefaultBillingAddressSelector(store),
      currentAccountSummary: CurrentAccountSummarySelector(store),
      currentCustomerId: CurrentCustomerIdSelector(store),
      currentHousehold: CurrentHouseholdSelector(store),
      currentMemberCanCreatePaymentInstrument: CurrentMemberHasCreatePaymentInstrumentPermissionsSelector(store),
      currentPostPaidAccountSummary: CurrentPostPaidAccountSummarySelector(store),
      defaultPaymentMethod: DefaultPaymentMethodAutoPaySelector(store),
      eWalletError: EwalletErrorSelector(store),
      isCreatingOrEditingPaymentMethodData: PaymentIsCreatingOrEditingDataSelector(store),
      isFetchingEwalletData: IsRetrievingEwalletDataSelector(store),
      isFetchingSubscriberSummary: IsFetchingSubscriberSummarySelector(store),
      isUpdatingAutoPayData: PaymentIsUpdatingAutoPaySelector(store),
      paymentInstruments: PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesAutoPayViewModelSelector(store),
      paymentInstrumentSummaries: PaymentInstrumentSummariesSelector(store),
      postPaidSubscriberSummaryAccounts: ConvergentBillerSubscriberSummaryPostPaidAccountSelector(store),
      prepaidSubscriberSummaryAccounts: ConvergentBillerSubscriberSummaryPrePaidAccountSelector(store),
      selectedPaymentMethodPaymentAccountsSelector: SelectedPaymentMethodConvergentBillerPaymentInstrumentAccountsSelector(store),
      selectedPaymentMethod: SelectedPaymentMethodSelector(store),
      subscriberSummary: ConvergentBillerSubscriberSummarySelector(store),
      subscriberSummaryAccounts: ConvergentBillerSubscriberSummaryAccountsSelector(store),
      lastRoute: SessionSelectors.LastRouteSelector(store)
    };
  };
  var controllerActions = {
    chargePaymentInstrument: chargePaymentInstrument,
    clearSelectedPaymentMethod: clearSelectedPaymentMethod,
    editPaymentInstrument: editPaymentInstrument,
    fetchCodeTypes: MetadataActions.codes.fetchCodeTypes,
    retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
    retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
    retrieveWallet: retrieveWallet,
    retrieveCustomerHouseholds: retrieveCustomerHouseholds,
    selectPaymentMethod: selectPaymentMethod,
    setCustomerAutoPayBannerFlag: setCustomerAutoPayBannerFlag,
    setPaymentInstrumentDefault: setPaymentInstrumentDefault,
    stateGo: stateGo,
    updatePaymentAccountsOnSelectedPaymentMethod: updatePaymentAccountsOnSelectedPaymentMethod,
    unregisterUnsavedChanges: UnsavedChangesPromptActions.unregisterUnsavedChanges
  };
  this.$onInit = function () {
    _this.LocaleKeys = LocaleKeys;
    _this.DEFAULT_BACK_ROUTE = DASHBOARD_ROUTE;
    _this.submitText = LocaleKeys.AUTO_PAY.UPDATE;
    _this.confirmDeactivation = false;
    _this.showFields = false;
    _this.suspendType = SUSPENSION_TYPE.INDEFINITE;
    _this.suspendTypes = SUSPENSION_TYPE;
    _this.minDate = new Date().setDate(new Date().getDate() + 1);
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    fetchRequiredData();
    _this.optionalParams = {
      customerId: _this.state.currentCustomerId
    };
    _this.mainFormServiceError = '';
    _this.changeAutoPayAccountActivationPopUp = {
      onRegisterApi: function onRegisterApi(evt) {
        _this.changeAutoPayAccountActivationPopUp = evt.api;
      }
    };
    _this.actions.retrieveAvailablePaymentInstrumentTypes().catch(function (error) {
      uiNotificationService.transientError(error.translatedMessage);
    });
  };
  var fetchRequiredData = function fetchRequiredData() {
    _this.actions.retrieveConvergentBillerSubscriberSummary(_this.state.currentCustomerId).then(function () {
      _this.selectedAccount = _this.state.currentAccountSummary;
      _this.actions.retrieveWallet(_this.buildWalletRequest()).then(function () {
        _this.setCurrentlySelectedPaymentInstrument(_this.state.defaultPaymentMethod);
      });
      _this.accountSummaryEditCopy = _this.state.currentAccountSummary.asMutable({
        deep: true
      });
      _this.showFields = _this.accountSummaryEditCopy.AutoPayConfigured;
      _this.setSelectedSuspension();
    });
    if (!_this.state.currentHousehold) {
      _this.actions.retrieveCustomerHouseholds(_this.state.currentCustomerId, false);
    }
  };
  this.setSelectedSuspension = function () {
    if (_this.accountSummaryEditCopy.AutoPayConfigured) {
      if (_this.accountSummaryEditCopy.AutoPaySuspensionEndDate && _this.accountSummaryEditCopy.AutoPaySuspended) {
        _this.suspendType = SUSPENSION_TYPE.UNTIL;
      } else if (!!_this.accountSummaryEditCopy.AutoPaySuspensionEndDate && _this.accountSummaryEditCopy.AutoPaySuspended) {
        _this.suspendType = SUSPENSION_TYPE.INDEFINITE;
      }
    }
  };
  this.continueDeactivatingAutopay = function (shouldDeactivateAutopay) {
    if (shouldDeactivateAutopay) {
      _this.confirmDeactivation = true;
      _this.showFields = _this.accountSummaryEditCopy.AutoPayConfigured;
      _this.actions.updatePaymentAccountsOnSelectedPaymentMethod({
        ConvergentBillerPaymentInstrumentAccounts: _this.getUpdatedPaymentAccountsForSelectedPaymentMethod()
      });
    } else {
      _this.accountSummaryEditCopy.AutoPayConfigured = true;
    }
    _this.changeAutoPayAccountActivationPopUp.close();
  };
  this.$onDestroy = function () {
    _this.actions.clearSelectedPaymentMethod();
    disconnectRedux();
  };
  this.shouldShowErrorForMainForm = function () {
    return _this.formApi.$submitted && (!_this.state.selectedPaymentMethod || _this.hasNoPaymentInstruments() || _this.isSuspensionDateRequired());
  };
  this.shouldShowErrorForMainFormField = function (fieldName) {
    return _this.formApi[fieldName] && (_this.formApi[fieldName].$touched || _this.formApi.$submitted) && _this.formApi[fieldName].$invalid;
  };
  this.getUpdatedPaymentAccountsForSelectedPaymentMethod = function (dateSelected, autoPayStatus) {
    if (_this.selectedAccount && _this.state.selectedPaymentMethod) {
      var paymentInstrumentPaymentAccounts = reject(function (currAccount) {
        return currAccount.AccountNumber === _this.selectedAccount.AccountNumber;
      }, _this.state.selectedPaymentMethodPaymentAccountsSelector);
      if (_this.accountSummaryEditCopy.AutoPayConfigured && _this.accountSummaryEditCopy.AutoPaySuspended && _this.suspendType === SUSPENSION_TYPE.UNTIL && (dateSelected || _this.accountSummaryEditCopy.AutoPaySuspensionEndDate)) {
        _this.accountSummaryEditCopy.AutoPaySuspensionEndDate = dateSelected || _this.accountSummaryEditCopy.AutoPaySuspensionEndDate;
      } else {
        _this.accountSummaryEditCopy.AutoPaySuspensionEndDate = undefined;
      }
      paymentInstrumentPaymentAccounts.push({
        AutoPay: autoPayStatus ? autoPayStatus : _this.accountSummaryEditCopy.AutoPayConfigured,
        AccountNumber: _this.selectedAccount.AccountNumber,
        AutoPaySuspended: _this.accountSummaryEditCopy.AutoPayConfigured && _this.accountSummaryEditCopy.AutoPaySuspended ? _this.accountSummaryEditCopy.AutoPaySuspended : null,
        AutoPaySuspensionEndDate: _this.accountSummaryEditCopy.AutoPaySuspensionEndDate
      });
      return paymentInstrumentPaymentAccounts;
    }
    return [];
  };
  this.handleSetSuspensionDate = function () {
    if (_this.suspendType === SUSPENSION_TYPE.INDEFINITE) {
      _this.accountSummaryEditCopy.AutoPaySuspensionEndDate = undefined;
    }
    _this.editAutoPayOnPaymentMethod();
  };
  this.editAutoPayOnPaymentMethod = function (dateSelected) {
    _this.actions.updatePaymentAccountsOnSelectedPaymentMethod({
      ConvergentBillerPaymentInstrumentAccounts: _this.getUpdatedPaymentAccountsForSelectedPaymentMethod(dateSelected)
    });
  };
  this.editAutoPayActivation = function (autoPayStatus) {
    if (_this.accountSummaryEditCopy.AutoPayConfigured && !_this.confirmDeactivation && _this.state.currentAccountSummary.AutoPayConfigured) {
      _this.changeAutoPayAccountActivationPopUp.open();
    } else {
      _this.showFields = !_this.accountSummaryEditCopy.AutoPayConfigured;
      _this.actions.updatePaymentAccountsOnSelectedPaymentMethod({
        ConvergentBillerPaymentInstrumentAccounts: _this.getUpdatedPaymentAccountsForSelectedPaymentMethod(null, autoPayStatus)
      });
    }
  };
  this.setCurrentlySelectedPaymentInstrument = function (paymentInstrument) {
    _this.currentlySelectedPaymentInstrument = paymentInstrument;
    if (!isNil(paymentInstrument)) {
      _this.selectPaymentMethod();
    } else {
      _this.actions.clearSelectedPaymentMethod();
    }
  };
  this.buildWalletRequest = function () {
    return {
      customerId: _this.state.currentCustomerId
    };
  };
  this.selectPaymentMethod = function () {
    _this.actions.selectPaymentMethod(_this.currentlySelectedPaymentInstrument);
    _this.editAutoPayOnPaymentMethod();
  };
  this.handleServiceError = function (errorMessageKey) {
    var serviceErrorAlert = i18n.translate(errorMessageKey);
    uiNotificationService.error(serviceErrorAlert, null, {
      timeOut: NOTIFICATION_TIME_LENGTH
    });
    if (_this.state.eWalletError && !_this.state.isCreatingOrEditingPaymentMethodData) {
      _this.mainFormServiceError = serviceErrorAlert;
    }
  };
  this.updateAutoPay = function () {
    if (!_this.selectedAccount || !_this.state.selectedPaymentMethod || _this.hasNoPaymentInstruments()) {
      return;
    }
    var request = {
      updateAutoPay: true,
      customerId: _this.state.currentCustomerId,
      request: {
        PaymentInstrument: _this.state.selectedPaymentMethod
      }
    };
    _this.mainFormServiceError = '';
    return _this.actions.editPaymentInstrument(request).then(function () {
      _this.actions.setCustomerAutoPayBannerFlag(_this.accountSummaryEditCopy.AutoPayConfigured && !_this.state.currentAccountSummary.AutoPayConfigured && !_this.accountSummaryEditCopy.AutoPaySuspended);
      uiNotificationService.success(i18n.translate(LocaleKeys.AUTO_PAY.SUCCESS), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
      _this.formApi.$setPristine();
      $state.go('index.customercare.customer.accountDashboard', {
        'customerId': parseInt(_this.state.currentCustomerId),
        'showAutoPayBanner': {
          enabled: _this.accountSummaryEditCopy.AutoPayConfigured && !_this.state.currentAccountSummary.AutoPayConfigured && !_this.accountSummaryEditCopy.AutoPaySuspended,
          customerId: parseInt(_this.state.currentCustomerId)
        }
      });
    }, function () {
      _this.handleServiceError(LocaleKeys.AUTO_PAY.FAILURE);
    });
  };
  this.isSuspensionDateRequired = function () {
    return _this.accountSummaryEditCopy.AutoPaySuspended && _this.accountSummaryEditCopy.AutoPayConfigured && _this.suspendType === SUSPENSION_TYPE.UNTIL && _this.formApi.$submitted && !_this.accountSummaryEditCopy.AutoPaySuspensionEndDate;
  };
  this.goBack = function () {
    var route = _this.state.lastRoute.name || _this.DEFAULT_BACK_ROUTE;
    var params = _this.state.lastRoute.params || {};
    $state.go(route, params);
  };
  this.hasNoPaymentInstruments = function () {
    return _this.state.paymentInstruments.length === 0;
  };
  this.showPageLoader = function () {
    return _this.state.isFetchingEwalletData || _this.state.isMakingPayment || _this.state.isFetchingSubscriberSummary || _this.state.isUpdatingAutoPayData;
  };
  this.getTitleKey = function () {
    return i18n.translate(LocaleKeys.AUTO_PAY.CONFIGURE_AUTO_PAY_HEADER, {
      account_number: _this.state.currentAccountSummary ? _this.state.currentAccountSummary.AccountNumber : ''
    });
  };
  this.canCreatePaymentInstruments = function () {
    if (!_this.state.currentHousehold) {
      return true;
    }
    return _this.state.currentMemberCanCreatePaymentInstrument;
  };
  this.onSubmit = function () {
    _this.formApi.$setSubmitted();
    if (!_this.isSuspensionDateRequired() && _this.state.selectedPaymentMethod) {
      _this.updateAutoPay();
    }
  };
}
export default {
  template: require('./configure.autopay.html'),
  controller: CustomerConfigureAutopayController,
  controllerAs: 'CustomerConfigureAutopayController'
};